import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { AuthPage } from './AuthPage';

export const ProtectedRoute = ({ children }: { children: JSX.Element }) => {
    const { isAuthorized, isVerified } = useSelector(
        ({ auth }: any) => ({
            isAuthorized: auth.user != null,
            isVerified: auth.isVerified,
        }),
        shallowEqual
    );

    if (!isAuthorized || !isVerified) {
        return <AuthPage />;
    }
    return children;
};
